import styled from 'styled-components';
import { Button } from 'kinedu-react-components';
import GoogleLogo from 'views/AuthView/assets/images/google.svg';

const StyledGoogleButton = styled(Button).attrs(({ altVersion }) => ({
  color: altVersion ? '#4285F4' : 'white',
  flat: true,
  rounded: true,
  small: true,
  fill: true,
}))`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0 20px;

  color: ${({ altVersion }) => (altVersion ? 'white' : '#757575')};
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;

  span {
    margin: auto;
  }

  ${({ disabled, altVersion }) =>
  disabled
    && `
    opacity: 0.4;
    background-color: ${altVersion ? '#4285F4' : 'white'};
  `}
`;

const GLogo = styled.img.attrs(() => ({ src: GoogleLogo }))<any> `
  width: 31px;
  ${({ altVersion }) => (altVersion ? '' : 'border-right: 1px solid #ACC2D3;')};
  padding: ${({ altVersion }) => (altVersion ? '6px' : '0 10px 0 0')};
  margin: 0 10px 0 0;
  border-radius: ${({ altVersion }) => (altVersion ? '100px' : '0px')};
  background-color: ${({ altVersion }) => altVersion ? 'white' : 'transparent'};
`;
export default StyledGoogleButton;
export { GLogo };
